import styles from './Avatar.module.css';

interface AvatarProps {
  name: string;
  imageUrl?: string | undefined;
  size?: number;
}

/**
 * 사람 동그라미.
 *
 * 사진이 없으면 이름 첫 글자. 빈 동그라미보다 낫고, 사진을 안 올린 사람의
 * 줄도 허전해 보이지 않는다. 바로 옆에 이름이 글자로 있으므로 보조기기에는
 * 감춘다 — 같은 것을 두 번 읽을 이유가 없다.
 *
 * ⚠️ **이름도 사진도 없으면 잉크색을 쓰지 않는다.** 아직 누군지 모르는
 * 상태(불러오는 중)인데, 다크 모드에서 잉크는 거의 흰색이라 글자 없는
 * 흰 원이 툭 떠올랐다가 사진으로 바뀐다. 그럴 때는 바탕에 가까운 색으로
 * 자리만 잡아 둔다.
 */
export function Avatar({ name, imageUrl, size = 40 }: AvatarProps) {
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };

  if (imageUrl !== undefined && imageUrl !== '') {
    return (
      <img
        className={styles.image}
        style={style}
        src={imageUrl}
        alt=""
        aria-hidden="true"
        /* 그리는 김에 같이 디코딩하게 둔다 — 헤더 아바타는 접힌 아래가 아니다 */
        decoding="async"
      />
    );
  }

  const letter = name.trim().slice(0, 1).toUpperCase();
  return (
    <span className={letter === '' ? styles.blank : styles.letter} style={style} aria-hidden="true">
      {letter}
    </span>
  );
}
